var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"elevation":"0","outlined":""}},[_c('div',{staticClass:"d-flex justify-center white lighten-3 pa-5 grey--text"},[_vm._v(" "+_vm._s(_vm.$t('emptyState.noData'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }